import { Stack, Container, Typography } from '@mui/material';
import TopupWithdrawTableView from 'src/sections/management/user/tabs/topup-withdraw/topup-withdraw-view';

export default function TopupWithdrawView() {
  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4" gutterBottom>
          รายการเติมและถอน
        </Typography>
        <TopupWithdrawTableView />
      </Stack>
    </Container>
  );
}
